import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Mixpanel } from '../Mixpanel';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      password: '',
      showError: false,
    }
  }

  componentDidMount() {
    Mixpanel.track('Open login');
  }

  showAuthError(authError) {
    const errorMsg = authError.non_field_errors.map(error => <div key={error}>{error}</div>);
    toast.error((
      <React.Fragment>
        {errorMsg}
      </React.Fragment>
    ), {
      position: toast.POSITION.BOTTOM_RIGHT
    });
    this.setState({
      showError: true,
    });
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      showError: false,
    })
  }

  submitForm = (e) => {
    Mixpanel.track('Login', {'Button': 'Login'});
    e.preventDefault();
    this.props.onSubmit(this.state.name, this.state.password)
      .catch((err) => this.showAuthError(err.response.data));
  }

  changeFormState(formState) {
    Mixpanel.track('Login', {'Button': formState})
    this.props.onFormStateChange(formState);
  }

  render() {
    const { formStates, requestInProgress } = this.props;
    const { showError } = this.state;
    return (
      <form className="auth-form" onSubmit={this.submitForm}>
        <div className='title'>Войти</div>
        <div className="auth-form-row">
          <label htmlFor="name">Никнейм</label>
          <input id='name' type="text" autoFocus={true} placeholder='никнейм'
            className={showError ? 'input-error' : ''}
            disabled={requestInProgress}
            onChange={this.handleInputChange} value={this.state.name} />
        </div>
        <div className="auth-form-row">
          <label htmlFor="password">Пароль</label>
          <input id='password' type="password" placeholder='пароль' 
              className={showError ? 'input-error' : ''}
              disabled={requestInProgress}
              onChange={this.handleInputChange} value={this.state.password} />
          <button className="btn_href" type="button" onClick={this.changeFormState.bind(this, formStates.RESET_PWD)} disabled={requestInProgress}>Забыли пароль?</button>
        </div>
        <div className="auth-form-row auth-buttons-block">
          <button className='btn btn_dark' type="submit" onClick={this.submitForm} disabled={requestInProgress}>Войти</button>
          <button className='btn btn_light' type="button" onClick={this.changeFormState.bind(this, formStates.REGISTER)} disabled={requestInProgress}>
            Зарегистрироваться
          </button>
        </div>
      </form>
    );
  }
}

Login.propTypes = {
  requestInProgress: PropTypes.bool.isRequired,
  formStates: PropTypes.object.isRequired,
  onFormStateChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Authorization/Login.js